import {useState} from "react";
import {showErrorNotification} from "../helpers/mainHelpers";
import { supCouncilInformationService} from "../services/supCouncilInfo-service";
import {GeneralInfoItem} from "../types/generalInfo";

export const useSupCouncilInformationController = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [supCouncilInfoList, setSupCouncilInfoList] = useState<GeneralInfoItem[]>([])
  const [selectedItem, setSelectedItem] = useState<GeneralInfoItem | undefined>(undefined)

  const fetchSupCouncilInfoItemsList = async (queries: string[]) => {
    setIsLoading(true)
    try {
      const list = await supCouncilInformationService.list(queries)
      setSupCouncilInfoList(list)
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка при отриманні інформації!"})
    } finally {
      setIsLoading(false)
    }
  }

  const getSupCouncilInfoItemData = async (id: string) => {
    setIsLoading(true)
    try {
      const data = await supCouncilInformationService.getById(id)
      setSelectedItem(data)
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка при завантаженні інформації!"})
    } finally {
      setIsLoading(false)
    }
  }

return {isLoading,supCouncilInfoList, fetchSupCouncilInfoItemsList, getSupCouncilInfoItemData, selectedItem}
}
